/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_ColorInputs */

const en_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Color...`)
};

const fr_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de l'intervenant...`)
};

const de_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecherfarbe...`)
};

const it_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore altoparlante...`)
};

const ru_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет динамика...`)
};

const es_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color del altavoz...`)
};

const zh_cn2_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扬声器颜色...`)
};

const ja_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの色...`)
};

const hi_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर का रंग...`)
};

const pt_pt2_speaker_color = /** @type {(inputs: Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor do alto-falante...`)
};

/**
* | output |
* | --- |
* | "Speaker Color..." |
*
* @param {Speaker_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_color = /** @type {((inputs?: Speaker_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_color(inputs)
	if (locale === "de") return de_speaker_color(inputs)
	if (locale === "it") return it_speaker_color(inputs)
	if (locale === "ru") return ru_speaker_color(inputs)
	if (locale === "es") return es_speaker_color(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_color(inputs)
	if (locale === "ja") return ja_speaker_color(inputs)
	if (locale === "hi") return hi_speaker_color(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_color(inputs)
	return en_speaker_color(inputs)
});